import { useQuery, UseQueryResult } from '@tanstack/react-query';
import NavigationService from 'src/services/navigation.service';

const headerQueryKey: string = 'header';
const footerQueryKey: string = 'footer';

export const useGlobalHeader = (): UseQueryResult<string> => {
    return useQuery<string>({
        queryKey: [headerQueryKey],
        queryFn: async () => await NavigationService.getGlobalHeader()
    });
};

export const useGlobalFooter = (): UseQueryResult<string> => {
    return useQuery<string>({
        queryKey: [footerQueryKey],
        queryFn: async () => await NavigationService.getGlobalFooter()
    });
};
